export const MORE_GAME_EVENTS_WIDGET_CLASS ='more-game-events-widget';
export const MORE_EVENTS_KEY = 'more_events';

export const I18N_CHANGE_EVENT = `${MORE_EVENTS_KEY}.change_event`;
export const I18N_CHANGE_EVENT_SEE_ALL = `${MORE_EVENTS_KEY}.see_all`;

export const MORE_GAMES_URL_ENDPOINT = '/more_games/fetchEvents';
export const MORE_GAMES_GTM_OPEN = 'change-event-open';
export const MORE_GAMES_GTM_CLOSE = 'change-event-close';
export const MORE_GAMES_GTM_SEE_ALL = 'change-event-seeall';
export const MORE_GAMES_GTM_CLICK_EVENT = 'change-event-clickevent';
